var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReport = function SvgReport(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 14.1001H4.5C4.2 14.1001 4 14.3001 4 14.6001V20.0001H6.9V14.6001C6.9 14.3001 6.7 14.1001 6.4 14.1001Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 12.3999H8.90002C8.60002 12.3999 8.40002 12.5999 8.40002 12.8999V19.9999H11.3V12.8999C11.3 12.6999 11 12.3999 10.8 12.3999Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1 10.8H13.2C13 10.8 12.7 11 12.7 11.3V20H15.6V11.3C15.6 11 15.4 10.8 15.1 10.8Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 9.19995H17.6C17.3 9.19995 17.1 9.39995 17.1 9.69995V20H20V9.69995C20 9.39995 19.8 9.19995 19.5 9.19995Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 10.4C4.4 10.4 4 10.1 4 9.59995C4 9.09995 4.3 8.79995 4.8 8.69995C4.9 8.69995 11.8 8.19995 16.7 5.29995C17.1 5.09995 17.6 5.19995 17.8 5.59995C18 5.99995 17.9 6.49995 17.5 6.69995C12.3 9.79995 5.2 10.4 4.8 10.4C4.9 10.4 4.9 10.4 4.8 10.4Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2999 7.6L19.5999 4.7C19.6999 4.4 19.4999 4 19.0999 4L15.9999 4.3C15.5999 4.3 15.3999 4.8 15.5999 5.1L17.3999 7.7C17.5999 8 18.0999 7.9 18.2999 7.6Z",
    fill: "url(#paint5_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 5.2805,
    y1: 12.7973,
    x2: 5.6825,
    y2: 23.6919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3663F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 9.90112,
    y1: 8.6542,
    x2: 9.77822,
    y2: 19.8436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3663F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 14.1346,
    y1: 9.69005,
    x2: 14.2177,
    y2: 19.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B53F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 18.5317,
    y1: 8.96805,
    x2: 18.5736,
    y2: 19.8668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0414298,
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7869,
    stopColor: "#F56D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 7.3294,
    y1: 3.30785,
    x2: 11.9456,
    y2: 9.02005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 12.7726,
    y1: -1.091,
    x2: 17.3888,
    y2: 4.6211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Report.f102b6d0.svg";
export { ForwardRef as ReactComponent };